<template src="./WeatherStationList.html"> </template>

<script>
import { mapState, mapActions } from 'vuex';

import WeatherStationCreate from '../WeatherStationCreate/WeatherStationCreate.vue';

export default {
    name: 'WeatherStationList',
    components: {
        WeatherStationCreate
    },
    data() {
        return {
            viewWsCreate: false,
            dialogs: { delete: false },
            selected: null,
        }
    },   
    computed: {
        ...mapState({
            ws: state => state.ws.ws,
            wsDeleting: state => state.ws.wsDeleting,
        }),

        wsTable() {
            const tableHeader = [
                { text: "Virtual Weather Station", value: 'name' },
                { text: "Latitude", value: "latitude" },
                { text: "Longitude", value: "longitude" },
                { text: "Actions", value: 'actions', sortable: false, align: 'end' }
            ];
            
            let tableData = [];
            this.ws.forEach(w => {
                tableData.push({
                    _id: w._id,
                    name: w.name,
                    latitude: w.loc.lat.toFixed(4),
                    longitude: w.loc.lon.toFixed(4),
                    pvt: !!w.pvt,
                });
            });

            return {
                header: tableHeader,
                data: tableData
            }
        }
    },
    methods: {
        ...mapActions({
            deleteVirtualWeatherStation: 'deleteVirtualWeatherStation',
            setAlert: 'setAlert',
        }),
        onViewWsCreate() {
            this.viewWsCreate = !this.viewWsCreate;
        },

        onCloseCreateVirtualStation(value) {
            this.viewWsCreate = value;
        },

        isDeleting(id) {
            return !!(id && this.wsDeleting && this.wsDeleting[id]);
        },

        confirmDelete(item) {
            this.selected = item;
            this.dialogs.delete = true;
        },

        closeDeleteDialog() {
            this.dialogs.delete = false;
            this.selected = null;
        },

        doDelete() {
            if (!(this.selected && this.selected._id)) return;
            this.deleteVirtualWeatherStation(this.selected._id);
            // Keep dialog open to show loading; auto-close when no longer deleting
            const id = this.selected._id;
            const check = () => {
                if (!this.isDeleting(id)) this.closeDeleteDialog();
                else setTimeout(check, 150);
            };
            setTimeout(check, 150);
        }
    },
}
</script>
<style lang="scss" src="./WeatherStationList.scss"> </style>